import { useQuery } from '@tanstack/react-query';
import { queryKeys, uuidRegEx } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { JobConcreteDirectRespSuccess } from './types';

export const useGetJobConcreteDirect = (open: boolean, jobId?: string, id?: string) => {
  const { data, error, isPending } = useQuery<JobConcreteDirectRespSuccess, ApiError>({
    queryKey: [...queryKeys.jobConcreteDirect, jobId, id],
    queryFn: () =>
      queryFetch({
        url: `jobs/${jobId}/concrete_directs/${id}`,
      }),
    placeholderData: (previousData) => previousData as JobConcreteDirectRespSuccess,
    enabled: open && Boolean(jobId && uuidRegEx.test(jobId)) && Boolean(id && uuidRegEx.test(id)),
  });

  return {
    data,
    error,
    isLoading:
      isPending &&
      open &&
      Boolean(jobId && uuidRegEx.test(jobId)) &&
      Boolean(id && uuidRegEx.test(id)),
  };
};
